import { UserFragment } from '@/graphql/fragments/generated/User';

export const getOptionLabel = (option: UserFragment) => option.name || option.uniqueId;

export const isOptionEqualToValue = (option: UserFragment, value: UserFragment) => {
  const optionLabel = option.uniqueId;
  const valueLabel = value.uniqueId;

  return optionLabel === valueLabel;
};
